import { Component, OnInit,Input,ViewChildren,EventEmitter,Output,ViewChild, NgZone} from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheetRef} from '@angular/material/bottom-sheet';
import { CookieService } from 'ngx-cookie-service';
import { ServiceBody } from 'src/app/models/serviceBody'
import { LoginService } from 'src/app/services/checkout-services/login.service';
import { NgOtpInputModule } from 'ng-otp-input';
import { Login, NewUser, otpVerify, forgetPassword } from '../../../models/User';
import { OtpService } from 'src/app/services/checkout-services/-otp.service';
import { IfStmt } from '@angular/compiler';
import { ForgetPasswordService } from 'src/app/services/checkout-services/forget-password.service';
import { AddressService } from 'src/app/services/checkout-services/address.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {
  @Output() redirect1:EventEmitter<any> = new EventEmitter();
  @Input() response = new ServiceBody();
  @Input() check : boolean;
  @ViewChildren('formRow') rows: any;
  @ViewChild('ngOtpInput',{static: false}) ngOtpInputRef:any;
  showErrorMessage: boolean = false;
  error: boolean = true;
  showRefer = false; 
  NewLogin = new Login();
  user = new NewUser() ;
  referralCode: string;
  forgetPasswordUser = new forgetPassword()
  addressId;
  timeLeft: number = 180;
  interval;
  obj = <HTMLInputElement>document.getElementById('partitioned');
  togglemyPassword: boolean = false
  otpNumber: string;
  mySignupPassword: string;
  verifyOtp = new otpVerify()
  userId: string;
  toggle: boolean = false;
  hide = true;
  constructor(private router: Router, 
    private loginService:LoginService,
    private _cookie: CookieService,
    private _bottomSheetRef: MatBottomSheetRef,
    public otpService : OtpService,
    public passwordService: ForgetPasswordService,
    private addressService: AddressService,
    private ngZone: NgZone,

    ) { 
      
  }
  yourMethod(){
    this.ngOtpInputRef.setValue('');//yourvalue can be any string or number eg. 1234 or '1234'
  }

  togglePassword(){
    this.verifyOtp.otp = +this.otpNumber;
    this.verifyOtp.otpId = this.response.otpId;
    this.verifyOtp.phoneNumber = +this.response.myNumber
    this.otpService.checkOtp(this.verifyOtp).subscribe(data=>{
      console.log(data.body);
      if(data.body){
        if(this.check == false){
          document.getElementById('newPassword').style.display="block";
          document.getElementById('text1').style.display="block";
          document.getElementById('text2').style.display="none";
          document.getElementById('otpChild').style.display="none";
        }
        else{
          document.getElementById('newPassword').style.display="block";
          document.getElementById('text1').style.display="none";
          document.getElementById('text2').style.display="block";
          document.getElementById('otpChild').style.display="none";
        }
        
      }
      else{
       this.yourMethod();
        this.showErrorMessage=true;
      }
    })
    if(this.referralCode){

    }
  }

  config = {
    allowNumbersOnly: false,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder:'0',
    inputStyles: {
      'width': '40px',
      'height': '50px'
    }
  };
  onOtpChange(otp) {
    this.otpNumber = otp;
  }

  showReferral(){
    this.showRefer = true;
  }

  resend(){
    this.yourMethod();
    this.timeLeft=30;
    document.getElementById("change").style.color = 'black'
      this.startTimer()
    this.otpService.sendOtp(this.response.myNumber).subscribe(data=>{
      this.response.otpId = data.body.otpId;
      
    })
}

startTimer() {
  this.interval = setInterval(() => {
    if(this.timeLeft > 0) {
      this.timeLeft--;
    } else {
      this.timeLeft = 30;
      document.getElementById("change").style.color = '#E91E63'
    }
  },1000)
}

  forgetUserCreate(){
    this.forgetPasswordUser.firstName = "Onelap";
    this.forgetPasswordUser.lastName = "User";
    this.forgetPasswordUser.otp = this.otpNumber;
    this.forgetPasswordUser.otpId = this.response.otpId;
    this.forgetPasswordUser.phoneNumber=this.response.myNumber;
    this.forgetPasswordUser.password =  this.mySignupPassword;
    this.passwordService.forgetPassword(this.forgetPasswordUser).subscribe(data=>{
      this.userId = data.body.userId;
        this.toggle = !this.toggle;
        this._bottomSheetRef.dismiss(); 
        this.NewLogin.phoneNumber=this.response.myNumber;
        this.NewLogin.password = this.mySignupPassword
        this.loginService.loginUser(this.NewLogin).subscribe(data=>{
  
          this._cookie.set("Authorization", data.headers.get('Authorization'));
          this._cookie.set('UserID', data.headers.get('UserID'));
    
          if (this._cookie.get('productId')) {
              this.ngZone.run(() =>
              this.router.navigate(['/order-and-address']));
        } else {
          this.ngZone.run(() =>
          this.router.navigate(['/my-account']));
        }
           });
    })
  }

  createUser(){
      if(this.check == true){
        this.forgetUserCreate()
      }
      else{
        this.user.firstName = "Onelap",
        this.user.lastName ="User",
        this.user.phoneNumber =this.response.myNumber,
        this.user.password =this.mySignupPassword,
        this.user.otp =this.otpNumber,
        this.user.referredCode = this.referralCode?this.referralCode:null;
        this.user.otpId=this.response.otpId
        this.loginService.userCreate(this.user).subscribe(data=>{
        this.userId = data.body.userId;
        this.toggle = !this.toggle;
        this._bottomSheetRef.dismiss(); 
        this.NewLogin.phoneNumber=this.response.myNumber;
        this.NewLogin.password = this.mySignupPassword
        this.loginService.loginUser(this.NewLogin).subscribe(data=>{
          this.addressService.getAddress(data.headers.get('userID'), data.headers.get('Authorization')).subscribe(data => {
            this.addressId = data.body[0].addressId;
            this._cookie.set('addressId', this.addressId);
     
          });
        this._cookie.set("Authorization", data.headers.get('Authorization'));
        this._cookie.set('UserID', data.headers.get('UserID'));
  
        if (this._cookie.get('productId')) {
        this.router.navigate(['/order-and-address']);
  
      } else {
        this.router.navigate(['/my-account']);
      }
         });
      },
      error=>{
        this.redirect1.emit(this.error)
      });
      }
      
  }
  ngOnInit() {
    document.getElementById('otpChild').style.display="block";
    document.getElementById('newPassword').style.display="none";
    if(this.check==false){
      document.getElementById('refer').style.display="block";
    }
    else{
      document.getElementById('refer').style.display="none";

    }
  }
  goToLogin(){
    this.redirect1.emit(this.error)
  }

}